<template>
  <div class="filter filter--block mb-4">
    <div class="flex px-3">
      <div class="mr-3">📊</div>
      <div class="flex flex-row-between flex--center" style="width: 100%">
        <div v-if="total_data.total_active">
          {{ $t('phone-number.number.badge.total_active') }} {{ total_data.total_active }}
        </div>
        <div v-if="total_data.total_active">
          {{ $t('phone-number.number.badge.total') }} {{ total_data.total }}
        </div>
        <div>
          <tooltip
            v-if="total_data.total_fee"
            class="ml-3"
            placement="left"
            min-width="300"
            max-width="300"
            theme="light"
            :content="$t('phone-number.number.tooltips.fee')"
          >
            {{ $t('phone-number.number.badge.fee') }} {{ total_data.total_fee }}
            <icon size="18" type="ios-help-circle-outline" />
          </tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('phone-number/numbers/table', ['meta']),

      total_data: function () {

        const { total, total_active, total_subscription_fee } = this.meta;
        return {
          total,
          total_active,
          total_fee: this.$numeral.currency(total_subscription_fee)
        };
      }
    },
  };
</script>
